<template>
  <div class="flex-1 connect-upgrade" :class="{ 'upgrade-home': !is_in_iframe }">
    <div v-if="first_loading" class="full-width full-height flex items-center justify-center">
      <Loading />
    </div>
    <div v-else-if="state == 'success'" class="full-width full-height flex flex-column items-center justify-center p-20">
      <div class="my-20">
        <lottie-player autoplay loop mode="normal" :src="lottie_url" style="height: 180px" class="inline-block"> </lottie-player>
      </div>
      <h1 class="strong">Congratulations!</h1>
      <br />
      <h6 class="strong mb-10">Your Weezly account have been upgraded!</h6>
      <h6 class="strong">If you have any questions about Weezly and how to use it, don't hesitate to contact us.</h6>
    </div>
    <template v-else>
      <perfect-scrollbar class="upgrade-form p-20">
        <div style="width: 416px" class="max-full-width margin-auto">
          <div class="align-center mb-20">
            <img src="@/assets/img/icons/premium-badge.png" width="96px" />
          </div>

          <div v-if="billing.subscription" class="p-20 align-center">
            <h5 class="strong">You are having subscription!</h5>
          </div>

          <div v-else>
            <h6 v-if="billing.expiring" class="align-center color-lip mb-20">
              <em
                >Your <span class="uppercase">{{ me_plan.plan_name }}</span> tier will expire on
                {{ moment(billing.expiring.sub_end, "X").format("DD MMMM, YYYY") }}</em
              >
            </h6>

            <!-- Card -->
            <div v-if="!billing.card" class="mb-20">
              <div class="align-center mb-20">
                <h5 class="strong max-full-width inline-block" style="width: 320px">Enter your card details to upgrade your Weezly Connect!</h5>
              </div>
              <Card ref="card" />
            </div>
            <div v-else class="mb-20">
              <div class="align-center mb-20">
                <h5 class="strong max-full-width inline-block" style="width: 320px">Upgrade your Weezly Connect</h5>
              </div>
              <UpdateCard :card="billing.card" @cardUpdated="$emit('cardUpdated')" />
            </div>

            <!-- Billling address details -->
            <div class="mb-20">
              <div class="flex items-center" v-if="show_business_toggle">
                <h6 class="mb-0">I'm purchasing as a business</h6>
                <div class="flex-1"></div>
                <Switcher
                  :value="show_billing_details"
                  :fat="true"
                  @input="
                    (value) => {
                      show_billing_details = value;
                    }
                  " />
              </div>
              <BillingTax
                class="font-body mt-10 p-15 div-border bg-white border-radius-4"
                :class="{ hide: !show_billing_details }"
                @added="
                  show_business_toggle = false;
                  calculate();
                "
                @removed="
                  show_business_toggle = true;
                  show_billing_details = false;
                  calculate();
                " />
            </div>

            <!-- Discount code -->
            <div class="mb-20">
              <div class="flex items-center">
                <h6 class="mb-0">I have coupon <i class="la la-tag"></i></h6>
                <div class="flex-1"></div>
                <Switcher :value="show_coupon" :fat="true" @input="toggleCoupon" />
              </div>

              <div class="flex items-center mt-10 bg-white border-radius-4 px-10" :class="{ hide: !show_coupon }">
                <input
                  style="height: 36px"
                  class="font-h6 flex-1 no-border"
                  name="discount_code"
                  type="text"
                  placeholder="DISCOUNT CODE"
                  maxlength="30"
                  v-model="coupon_code"
                  @input="inputCoupon" />
                <span
                  v-if="coupon_status == 'valid'"
                  class="color-white color-white-darkmode bg-green border-radius px-5 sm-text ml-10 inline-flex items-center"
                  style="height: 18px"
                  >VALID</span
                >
                <span
                  v-else-if="coupon_status == 'invalid'"
                  class="color-white color-white-darkmode bg-lip border-radius px-5 sm-text ml-10 inline-flex items-center"
                  style="height: 18px"
                  >INVALID</span
                >
                <i v-else-if="coupon_status == 'loading'" class="la la-spinner spinning color-primary font-h5s ml-10"></i>
              </div>

              <p class="sm-text color-green align-right mt-5" v-if="the_price.discount != ''">
                You will get {{ the_price.discount }} of discount {{ the_price.duration_off == "forever" ? "forever" : "" }} on Weezly
              </p>
            </div>

            <!-- PAY button -->
            <button
              v-if="!billing.subscription"
              class="btn btn-primary py-15 free-height block strong font-h4 mb-20"
              :class="{ disabled: loading_price }"
              @click="submit">
              <i v-if="!loading" class="la la-flag-checkered mr-10"></i>
              <i v-else class="la la-spinner spinning mr-10"></i>
              <span class="uppercase mr-10">PAY</span>
              {{ loading_price ? ".." : `$${the_price.total}` }}
            </button>

            <!-- By Stripe -->
            <div class="align-center mt-10 flex items-center strong">
              All payment are managed by
              <img src="@/assets/img/icons/stripe.png" alt="Stripe" height="15px" class="ml-5" />
            </div>

            <!-- Total cost -->
            <div class="align-center strong mt-5">
              Your total monthly cost:
              <div class="nowrap inline">
                <strong>${{ the_price.price }}</strong>
                <strong v-if="the_price.discount != ''" class="color-green"> - {{ the_price.discount }} (discount)</strong>
                + <strong>VAT({{ the_price.vat }}%)</strong> = <strong>${{ the_price.total }}</strong>
              </div>
            </div>
          </div>
        </div>
      </perfect-scrollbar>

      <!-- RIGHT DETAIL -->
      <perfect-scrollbar class="premium-features" ref="scrollFeatures">
        <div class="align-center">
          <div class="premium-badge">
            <i class="la la-trophy"></i>
            <span>Premium features</span>
          </div>
          <h1 class="strong mt-10">What is included?</h1>
          <div class="font-h6 margin-auto max-full-width" style="width: 580px; line-height: 1.7em">
            Upgrade to experience the complete Weezly Connect toolkit, built to save you time, keep you organized, and turn every conversation into an
            opportunity.
          </div>
        </div>

        <br />

        <div class="premium-features-list mt-20">
          <div v-for="item in features" :key="item.name" class="item">
            <img :src="require(`@/assets/img/weezly-connect/${item.image}`)" alt="" class="mb-10 border-radius" />
            <h5 class="strong mb-5">{{ item.name }}</h5>
            <h6>{{ item.description }}</h6>
            <div class="premium-badge">
              <i class="la la-trophy"></i>
              <span>Premium</span>
            </div>
          </div>
        </div>
      </perfect-scrollbar>
    </template>
  </div>
</template>

<script>
import confetti from "canvas-confetti";
import request from "@/service";
import types from "@/constants/types";
import Card from "@/components/Upgrade/Card";
import UpdateCard from "@/components/Upgrade/UpdateCard";
import BillingTax from "@/components/Upgrade/BillingTax";
import moment from "moment";
export default {
  name: "WeezlyConnectUpgrade",
  components: {
    Card,
    UpdateCard,
    BillingTax,
  },
  props: {},
  data: function () {
    return {
      moment,
      billing: {
        subscription: false,
        tax: false,
        card: false,
        billing_address: false,
        invoices: [],
        packages: [],
        blackfriday: false,
      },

      plan_type: "connect_monthly",
      vat: 0,
      loading_price: false,
      loading: false,
      first_loading: true,
      state: "",

      percent_off: 0,
      amount_off: 0,
      duration_off: "",

      show_coupon: false,
      coupon_code: "",
      coupon_status: "",
      coupon_timeout: false,
      coupon_key: 0,

      show_business_toggle: false,
      show_billing_details: false,

      is_in_iframe: window.self !== window.top,

      features: [
        {
          name: "🎤 Send Voice Messages",
          description: "Add a personal touch with quick audio notes.",
          image: "voice-message.webp",
        },
        {
          name: "🎥 Record & Send Video Messages",
          description: "Create trust and connection instantly.",
          image: "video-message.webp",
        },
        {
          name: "📅 Book Meetings From Chat",
          description: "Propose times for a meeting instantly.",
          image: "book-meetings.webp",
        },
        {
          name: "🏷 Organize with Labels",
          description: "Always know where every lead stands.",
          image: "labels.webp",
        },
        {
          name: "⏰ Set Reminders & Follow Up",
          description: "Never let a deal go cold.",
          image: "reminders.webp",
        },
        {
          name: "📊 Manage Pipelines in LinkedIn",
          description: "Track prospects and deals seamlessly.",
          image: "pipelines.webp",
        },
        {
          name: "👤 Linkedin Profiles In Chat",
          description: "Get context before you reply.",
          image: "linkedin-profile.webp",
        },
        {
          name: "💬 Conversation Snippets",
          description: "Quick replies with saved snippets.",
          image: "snippets.webp",
        },
      ],
    };
  },
  beforeMount() {
    if (this.is_in_iframe) document.body.setAttribute("data-theme", "light");
  },
  async mounted() {
    if (this.is_in_iframe) {
      document.body.setAttribute("data-theme", "light");

      try {
        window.parent.postMessage("weezly-connect-iframe-loaded", "*");
      } catch {}

      window.addEventListener("message", async (event) => {
        if (event.data.type == "weezly-connect-authorization") {
          let new_token = event.data.token;
          if (new_token) {
            window.localStorage.setItem("token", new_token);
            await this.loadData();
          }
        }
      });
    } else {
      await this.loadData();
    }
  },
  computed: {
    the_price() {
      let price = {
        price: "..",
        vat: this.vat,
        total: "..",
        discount: "",
        duration_off: this.duration_off,
      };

      if (this.the_plan.plan_price) {
        let p = parseFloat(this.the_plan.plan_price);

        price.price = p;

        if (this.percent_off) {
          price.discount = this.percent_off + "%";
          let discount = (p * this.percent_off) / 100;
          p = p - discount;
        } else if (this.amount_off) {
          price.discount = "$" + this.amount_off;
          p = p - this.amount_off;
        }
        if (p < 0) p = 0;

        let vat_price = (p * this.vat) / 100;
        let total = p + vat_price;

        price.total = Math.round(total * 100) / 100;
      }

      return price;
    },
    the_plan() {
      let p = this.billing.packages.find((p) => p.plan_type == this.plan_type);
      return p || {};
    },
    me() {
      return this.$store.getters.getMe;
    },
    me_plan() {
      let me = this.me;
      if (!me) return {};
      let billed = "";
      if (me.plan_type.endsWith("_monthly")) billed = "Mothly";
      else if (me.plan_type.endsWith("_yearly")) billed = "Yearly";
      else if (me.plan_type.endsWith("_trial")) billed = "Trial";
      return {
        plan_type: me.plan_type,
        quantity: me.quantity,
        plan_name: me.plan_type.replace("_monthly", "").replace("_yearly", "").replace("_trial", ""),
        billed: billed,
      };
    },
    lottie_url() {
      return window.location.origin + "/external/assets/congratulations.json";
    },
  },
  methods: {
    async loadData() {
      await this.$store.dispatch({
        type: types.getMeInfo,
      });
      const getData = await request("GET", "stripe/getBilling?plan_type=connect_monthly");
      if (getData) {
        this.billing = getData.data;
        this.calculate();
        this.first_loading = false;
        this.$nextTick(() => {
          if (this.$refs.scrollFeatures) this.$refs.scrollFeatures.ps.update();
        });
      } else {
        this.$root.$emit("alert", "Could not get your data. Please try again.", "error");
      }
    },
    async submit() {
      if (this.loading || this.loading_price || this.coupon_status == "loading") return false;

      this.loading = true;

      if (this.$refs.card) {
        const token = await this.$refs.card.createToken();
        if (!token) {
          this.loading = false;
          return false;
        }

        // Step 1: Create payment method AND stripe customer
        const responsePayment = await request("POST", "stripe/addPaymentMethod", {
          token: token,
        });

        if (!responsePayment) {
          this.$root.$emit("alert", this.$t("upgrade.something_wrong"), "error");
          this.loading = false;
          return false;
        }
      }

      // Step 2: Create a subscription
      let subscribe = await request("POST", "weezly-connect/subscribe", {
        plan_type: this.the_plan.plan_type,
        coupon_code: this.coupon_code != "" && this.coupon_status == "valid" ? this.coupon_code : null,
      });

      // Step 3: Confirm payment
      if (subscribe) {
        const { error, paymentIntent } = await this.$stripe.confirmPayment({
          clientSecret: subscribe.data.clientSecret,
          confirmParams: {
            // return_url: window.location.origin + "/upgrade?state=success",
          },
          redirect: "if_required",
        });

        if (error) {
          this.$root.$emit("alert", "Could not confirm payment", "error");
        } else if (paymentIntent && paymentIntent.status === "succeeded") {
          const check_intent = await request("POST", "stripe/checkIntent?from=frontend", {
            payment_intent: paymentIntent.id,
            payment_intent_client_secret: paymentIntent.client_secret,
          });

          if (check_intent) {
            if (check_intent.data.total) {
              try {
                dataLayer.push({
                  event: "purchase",
                  currency: "USD",
                  value: check_intent.data.total,
                });
              } catch (e) {}
            }

            this.state = "success";
            this.confettiCannons();
            try {
              window.parent.postMessage("weezly-connect-refresh", "*");
            } catch {}
          }
        }
      }
      this.loading = false;
    },

    // Billing Tax
    async calculate() {
      this.loading_price = true;
      const response = await request("POST", "stripe/calculateTax", {
        plan_type: this.the_plan.plan_type,
      });

      if (response) {
        this.vat = response.data.percentage;

        if (!this.show_billing_details) {
          const billing_details = await request("GET", "stripe/getBillingDetails");
          if (billing_details && billing_details.data) this.show_business_toggle = false;
          else this.show_business_toggle = true;
        }

        this.loading_price = false;
      } else {
        this.$root.$emit("alert", "Could not calculate the price!", "error");
      }
    },

    // Coupon
    toggleCoupon(value) {
      this.show_coupon = value;
      clearTimeout(this.coupon_timeout);
      this.percent_off = 0;
      this.amount_off = 0;
      this.duration_off = "";
      this.coupon_status = "";
      this.coupon_code = "";
    },
    async inputCoupon() {
      clearTimeout(this.coupon_timeout);
      let coupon_code = this.coupon_code.trim();

      this.percent_off = 0;
      this.amount_off = 0;
      this.duration_off = "";

      if (coupon_code == "") {
        this.coupon_status = "";
      } else {
        this.coupon_status = "loading";

        this.coupon_timeout = setTimeout(async () => {
          const response = await request("POST", "stripe/checkCouponStatus", {
            coupon_code: coupon_code,
            plan_type: this.the_plan.plan_type,
          });

          if (!this.show_coupon) return false;

          if (!response && coupon_code == this.coupon_code.trim()) {
            this.coupon_status = "invalid";
          } else if (response && response.data.coupon_code == this.coupon_code.trim()) {
            let coupon_data = response.data;
            if (coupon_data.status == "valid" && !coupon_data.trial_days) {
              this.coupon_status = "valid";
              this.percent_off = parseInt(coupon_data.percent_off);
              this.amount_off = parseInt(coupon_data.amount_off) / 100;
              this.duration_off = coupon_data.duration_off;
            } else {
              this.coupon_status = "invalid";
            }
          }
        }, 1000);
      }
    },

    confettiCannons() {
      var count = 300;
      var defaults = {
        origin: { y: 0.7 },
      };
      var end = Date.now() + 1.5 * 1000;
      var colors = ["#bb0000", "#ffffff"];

      (function frame() {
        confetti({
          particleCount: 2,
          angle: 60,
          spread: 55,
          origin: { x: 0 },
          colors: colors,
        });
        confetti({
          particleCount: 2,
          angle: 120,
          spread: 55,
          origin: { x: 1 },
          colors: colors,
        });

        if (Date.now() < end) {
          requestAnimationFrame(frame);
        }
      })();

      function fire(particleRatio, opts) {
        confetti(
          Object.assign({}, defaults, opts, {
            particleCount: Math.floor(count * particleRatio),
          }),
        );
      }

      fire(0.25, {
        spread: 26,
        startVelocity: 55,
      });
      fire(0.2, {
        spread: 60,
      });
      fire(0.35, {
        spread: 100,
        decay: 0.91,
      });
      fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
      });
      fire(0.1, {
        spread: 180,
        startVelocity: 45,
      });
    },
  },
};
</script>
